import React, { useEffect } from 'react';

import { captureError } from '../../utilities/error';
import { useRedirect } from '../../hooks/useRedirect';
import Loading from '../../components/loading/Loading';
import useUrlParam from '../../mp/hooks/useUrlParam';
import { useOpenBookmarkQuery } from '../../redux/rtk';
import { useAppSelector } from '../../hooks/useAppSelector';
import { profileSelectors } from '../../redux/selectors/profile';
import { updateMapType } from '../../redux/actions';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { MAP_TYPE } from '@larki/shared/types/user.type';

const OpenBookmarkPage = () => {
  const redirect = useRedirect();
  const shareToken = useUrlParam('shareToken');
  const dispatch = useAppDispatch();
  const isHighResEnabled = useAppSelector(profileSelectors.getHighResEnabled);

  const openBookmarkState = useOpenBookmarkQuery(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    { shareToken: shareToken!, redirectToRequestAccess: true },
    { skip: !shareToken }
  );

  useEffect(() => {
    const error = openBookmarkState.error;
    if (error) captureError(error);
  }, [openBookmarkState.error]);

  useEffect(() => {
    const data = openBookmarkState.data;
    if (data && data.redirectUrl) {
      dispatch(
        updateMapType(
          isHighResEnabled ? MAP_TYPE.HIGHRES : MAP_TYPE.SATELLITE,
          true
        )
      );
      redirect.push(data.redirectUrl);
    }
  }, [openBookmarkState.data, redirect]);

  return <Loading />;
};

export default OpenBookmarkPage;
